import React from 'react';

import { TermsAgreeMessage } from '@interlayer/js/app/components/main/Registration/components/fields/PreferencesFields/components/TermsCheckbox/TermsCheckbox';
import { Checkbox } from '@interlayer/js/components/common/Fields/Checkbox';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import style from '../../PreferencesFields.scss';
import styleBlockInfoPopup from './styleBlockInfoPopup.scss';
import styleBlockInfo from '@interlayer/js/app/components/main/Registration/components/common/BlockInfo/BlockInfo.scss';

export const TermsCheckbox = ({ isInConfirmPopup = false }) => {
    const { isUpgrade } = useRegistrationSelector();

    if (isUpgrade) {
        return null;
    }

    const blockInfoStyle = isInConfirmPopup ? styleBlockInfoPopup.container : styleBlockInfo.container;

    return (
        <Checkbox
            reverse
            isTransparent
            type="checkbox"
            name={VALIDATION_FIELDS.terms}
            label={<TermsAgreeMessage />}
            classNames={{
                checkbox: clsx(blockInfoStyle, style.checkboxTerms)
            }}
        />
    );
};
